export default __webpack_public_path__ + "static/media/btn_big_purchasegmx.c47415ff.svg";